module.exports = __webpack_public_path__ + "img/m-hd.3aac8d0e.jpg";